/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockReport
 * @description Data access service for getting stock report data
 */
angular.module('mercury.modules.stock.report')
.factory('StockReport', ["$http", "$q", "settings", function($http, $q, settings) {

  const transformToReportFormat = (stockReceivedDocuments, companyId) => {
    const receivedItems = Object.values(stockReceivedDocuments
      .flatMap(doc => doc.lines)
      .reduce((acc, line) => {
        if (!acc[line.itemId]) {
          acc[line.itemId] = {
            itemId: line.itemId, 
            quantityInBaseUnits: 0, 
            totalCost: 0
          }
        } 
        acc[line.itemId].quantityInBaseUnits += line.quantityReceived * line.unitRatio
        acc[line.itemId].totalCost += line.quantityReceived * line.unitCost
        return acc
      },{})
    )

    const config = {
      params: {}
    };

    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    // If we don't need many items then just fetch the necessary ones.
    // Long query strings get rejected by our app server so get them all if we need loads
    if (receivedItems.length < 100) {
      config.params.ids = receivedItems.map(line => line.itemId)
    }

    return receivedItems.length === 0 ? $q.resolve([]) :
      $http.get(`${settings.stockHost}/internal/items/`, config)
      .then(function(response) {
        const items = response.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});

        return receivedItems.map((line) => ({
          stockItemId: line.itemId,
          stockItemName: items[line.itemId].name,
          cost: line.totalCost,
          quantity: line.quantityInBaseUnits,
          unitName: items[line.itemId].orderingUnitName,
          unitRatio: items[line.itemId].orderingUnitRatio,
          stockItemSharedItemId: items[line.itemId].sharedItemId
        }));
      });
  }

  /**
   * Get a summary of purchases between a period, grouped by item
   *
   * @memberof StockReport
   * @param  {String} startTime start of the period
   * @param  {String} endTime   end of the period
   */
  function getItemPurchasesReport(startTime, endTime, companyId) {
    const deferred = $q.defer();
    const config = { params: {
      from: startTime,
      to: endTime,
      property: 'Received'
    }};

    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(`${settings.stockHost}/internal/stock-received`, config)
    .then(function(result) {
      deferred.resolve(transformToReportFormat(result.data, companyId));
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  return {
    getItemPurchasesReport: getItemPurchasesReport,
  };
  
}]);
